import React from 'react'
import { ReactComponent as ChevronDownIcon } from 'assets/icons/cheveron-down.svg'
import InitialAvatar from 'shared/components/InitialAvatar/InitialAvatar'
import {
	ASSIGNED_STUDENTS_COUNT,
	STUDENTS,
	STUDENTS_PREVIEW_LIMIT,
} from '../../data/settingsData'
import s from './StudentList.module.scss'

export const StudentList = ({ studentsOpen, onShowMore }) => {
	const visibleStudents = STUDENTS.slice(
		0,
		studentsOpen ? STUDENTS.length : STUDENTS_PREVIEW_LIMIT,
	)

	return (
		<section className={s.list}>
			<div className={s.list__head}>
				<h2 className={s.list__title}>
					Assigned students{' '}
					<small className={s.list__count}>({ASSIGNED_STUDENTS_COUNT})</small>
				</h2>
			</div>
			<div className={s.list__rows}>
				{visibleStudents.map(student => (
					<div key={student.id} className={s.list__row}>
						<InitialAvatar
							name={student.name}
							avatarKey={student.avatarKey}
							size={38}
						/>
						<strong className={s.list__name}>{student.name}</strong>
						<span className={s.list__grade}>Grade {student.grade}</span>
						<span className={s.list__applications}>
							<strong className={s.list__value}>{student.applications}</strong> applications
						</span>
						<span className={s.list__assignments}>
							<strong className={s.list__value}>{student.assignments}</strong> assignments
						</span>
					</div>
				))}
			</div>
			{!studentsOpen ? (
				<button type="button" className={s.list__more} onClick={onShowMore}>
					Show more students
					<ChevronDownIcon className={s.list__moreIcon} aria-hidden />
				</button>
			) : null}
		</section>
	)
}

export default StudentList
